/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.sort.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Group from 'vux/src/components/group';
import Cell from 'vux/src/components/cell';
import Confirm from 'vux/src/components/confirm';
import XButton from 'vux/src/components/x-button';
import XTextarea from 'vux/src/components/x-textarea';
import PopupPicker from 'vux/src/components/popup-picker';
import TransferDom from 'vux/src/directives/transfer-dom';
import { Dialog, Toast } from 'vant';
export default {
  name: 'OrderPay',
  directives: {
    TransferDom: TransferDom
  },
  components: {
    XButton: XButton,
    Group: Group,
    Cell: Cell,
    PopupPicker: PopupPicker,
    Confirm: Confirm,
    XTextarea: XTextarea
  },
  data: function data() {
    return {
      setting: "",
      allmoney: '',
      //在扣款失败情况下获取客户账户余额 单位是元
      koumanoey: 0,
      wezf: false,
      goods: [],
      foods: [],
      addressList: [[]],
      //真的挺无奈的vux真的垃圾
      address: [],
      required: false,
      showPay: false,
      showPays: false,
      showConfirm: false,
      mealList: [],
      totalNum: 0,
      totalPrice: 0,
      orderDate: '',
      placeId: '',
      //场所编号
      radio: '1',
      placeName: '',
      //餐厅名称
      week: '',
      windowName: '',
      //窗口名称
      weekDay: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      //星期列表
      tangshi: '',
      peisong: '',
      waidai: '',
      isDisabled: false
    };
  },
  computed: {},
  watch: {
    radio: function radio(val) {
      if (val == '2') {
        if (this.addressList[0].length === 0) {
          this.$utils.Tools.toastShow('请联系管理配置送餐地点！');
          this.radio = 1;
        } else {
          this.required = true;
        }
      } else {
        this.required = false;
      }
    }
  },
  methods: {
    /*
     获取配送方式
    */
    getPlace: function getPlace() {
      var _this = this;

      this.$api.Meal.getPlace(this.placeId).then(function (response) {
        _this.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);
        } else {
          for (var j = 0; j < data.spareCol9.length; j++) {
            //支持堂食
            data.spareCol9[j] == 0 && data.spareCol9[j] == 0 ? _this.tangshi = true : ''; //支持配送

            data.spareCol9[j] == 1 && data.spareCol9[j] == 1 ? _this.peisong = true : ''; //支持外带

            data.spareCol9[j] == 2 && data.spareCol9[j] == 2 ? _this.waidai = true : '';
          }
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },

    /**
     * @function获取上一次订餐订单信息
     *      wzx
     *   2019.05.06
     **/
    getOrderInfo: function getOrderInfo() {
      var _this2 = this;

      this.$utils.Tools.loadShow();
      this.$api.Meal.getPlace(this.placeId).then(function (response) {
        _this2.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);
        } else {
          for (var j = 0; j < data.spareCol9.length; j++) {
            //支持堂食
            data.spareCol9[j] == 0 && _this2.tangshi ? _this2.tangshi = true : ''; //支持配送

            data.spareCol9[j] == 1 && _this2.peisong ? _this2.peisong = true : ''; //支持外带

            data.spareCol9[j] == 2 && _this2.waidai ? _this2.waidai = true : '';
          }

          if (data.addrId) {
            // this.require= true;
            _this2.address.push(data.addrId);
          } else {
            _this2.address = [];
          }
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },

    /**
     * @function获取送餐地点列表
     *      wzx
     *   2019.05.06
     **/
    getAddressList: function getAddressList() {
      var _this3 = this;

      this.$utils.Tools.loadShow();
      this.$api.Meal.getAddressList({}).then(function (response) {
        _this3.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this3.$code.success) {
          _this3.$utils.Tools.toastShow(msg);
        } else {
          if (data.length) {
            var _iterator = _createForOfIteratorHelper(data),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;

                /* 因为垃圾vux数据格式要求 */
                _this3.addressList[0].push({
                  name: item.addressName,
                  value: item.addressId
                });
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _this3.address = [_this3.addressList[0][0].value];
          }
        }
      }).catch(function () {
        _this3.$utils.Tools.httpError();
      });
    },

    /**
     * @function改变订餐菜品份数
     *      wzx
     *   2019.05.06
     **/
    changeNumber: function changeNumber(val, food, idx, index) {
      if (val === 1) {
        Toast('至少订一份哦');
      }

      var _iterator2 = _createForOfIteratorHelper(this.mealList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;

          if (item.mealId === this.goods[index].mealId && item.foodId === food.foodId) {
            item.foodOrder = val;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.$store.dispatch('actionFoodList', this.mealList);
      this.totalPrice = 0;
      this.totalNum = 0;
      var totalPrice = 0;

      var _iterator3 = _createForOfIteratorHelper(this.goods),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _item = _step3.value;

          var _iterator4 = _createForOfIteratorHelper(_item.foods),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _food = _step4.value;
              totalPrice += parseFloat((_food.foodPrice * _food.foodOrder).toFixed(2));
              this.totalNum += _food.foodOrder;
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this.totalPrice = Math.round(totalPrice * 100) / 100;
    },

    /**
     * @function新增订餐订单 提交支付
     *      wzx
     *   2019.05.07
     **/
    submitClick: function submitClick() {
      var _this4 = this;

      var orderInfo = JSON.stringify(this.goods);

      if (!this.tangshi && this.radio == 1) {
        Toast("未选取餐方式");
        return;
      }

      if (this.required && this.address.length === 0) {
        this.$utils.Tools.toastShow('请选择送餐地点！');
      } else {
        this.$utils.Tools.loadShow();
        this.$api.Meal.insertOrder({
          addrId: this.address.length > 0 ? this.address[0] : '',
          orderChannel: 1,
          orderDate: this.orderDate,
          orderState: 1,
          sendFlag: this.radio - 1,
          userName: this.$utils.Store.getItem('userLname'),
          userSerial: this.$utils.Store.getItem('userSerial'),
          placeId: this.placeId,
          orderInfo: orderInfo,
          orderPrice: this.totalPrice,
          cancelFlag: this.$route.query.cancelFlag,
          payType: this.$route.query.spareCol
        }).then(function (response) {
          _this4.$utils.Tools.loadHide();

          var code = response.code,
              msg = response.msg,
              data = response.data;

          if (+code !== _this4.$code.success) {
            if (+code === 610 || +code === 611 || +code === 612 || +code === 613 || +code === 614 || +code === 615 || +code === 616 || +code === 620 || +code === 621 || +code === 622 || +code === 623) {
              // // this.$utils.Tools.toastShow(msg);
              _this4.showPay = false; // 余额不足的code 615   616   620

              if ((code == 615 || code == 616 || code == 620) && _this4.setting.recharge == 1) {
                _this4.wezf = true; // 获取用户现有账户余额

                _this4.allmoney = data; // 计算出微信要扣的款

                _this4.koumanoey = ((parseInt(_this4.totalPrice * 100, 10) - parseInt(_this4.allmoney * 100, 10)) / 100).toFixed(2);
              } else {
                Dialog.alert({
                  title: '提示',
                  message: msg,
                  width: '75%',
                  confirmButtonText: '我知道了',
                  confirmButtonColor: '#3399ff'
                }).then(function () {// on close
                });
              }
            } else {
              _this4.showPay = false;
            }
          } else {
            _this4.$store.dispatch('actionFoodList', []);

            _this4.$utils.Tools.toastShow('订餐成功');

            setTimeout(function () {
              _this4.$router.replace('/OrderRecord');
            }, 1500); // this.$router.replace({path: '/OrderPayResult', query: {orderId: data}});
          }
        }).catch(function () {
          _this4.$utils.Tools.httpError();
        });
      }
    },
    //微信支付
    wxRecharge: function wxRecharge() {
      var _this5 = this;

      this.$api.Home.recharge({
        userSerial: this.$utils.Store.getItem('userSerial'),
        addMoney: this.koumanoey * 100 + '',
        openId: this.$utils.Store.getItem('openId')
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this5.$code.success) {
          _this5.$utils.Tools.toastShow(msg);
        } else {
          var params = {
            appId: data.appId,
            //公众号名称，由商户传入
            timeStamp: data.timeStamp,
            //时间戳，自1970年以来的秒数
            nonceStr: data.nonceStr,
            //随机串
            package: data.package,
            signType: data.signType,
            //微信签名方式：
            paySign: data.paySign //微信签名

          }; // 调起微信扣款界面 WeixinJSBridge.invoke ('getBrandWCPayRequest'，以及后端传回来的微信的一大堆东西)

          window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, function (res) {
            // 微信扣款成功
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 重新支付
              _this5.showPays = false; // 关闭微信支付按钮

              _this5.koumanoey = 0; //  直接调用再次订餐扣款

              setTimeout(function () {
                _this5.submitClick();
              }, 2000); // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            } else {
              // 支付失败
              _this5.showPay = false;
              Dialog.alert({
                title: '提示',
                message: '微信支付扣款失败',
                width: '75%',
                confirmButtonText: '我知道了',
                confirmButtonColor: '#3399ff'
              }).then(function () {// on close
              });
            }
          });
        }
      }).catch(function () {
        _this5.$utils.Tools.httpError();
      });
    },
    //再一次判断是微信小程序 还是 微信公众号环境
    onBridgeReady: function onBridgeReady() {
      var _this6 = this;

      this.$utils.Tools.getEnv(function (res) {
        // 微信小程序环境 带参进入微信小程序的逻辑
        if (res === 0) {
          _this6.$wechat.miniProgram.navigateTo({
            url: '../recharge/recharge?money=' + _this6.rechargeValue
          });
        } else {
          _this6.wxRecharge();
        }
      });
    },
    //当账户余额不足，直接进行微信在线支付，先判断是否是微信环境
    recharge: function recharge() {
      var _this7 = this;

      this.wezf = false; //获取当前环境

      this.$utils.Tools.getEnv(function (res) {
        //微信/微信小程序 环境
        if (res === 0 || res === 1) {
          if (typeof WeixinJSBridge == 'undefined') {
            // attachEvent()：标准的绑定事件监听函数的方法，是W3C所支持的，Chrome、FireFox、Opera、Safari、IE9.0及其以上版本都支持该函数
            if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', _this7.onBridgeReady, false);
            } else if (document.attachEvent) {
              //attachEvent()：8.0及其以下版本支持的绑定事件监听函数
              document.attachEvent('WeixinJSBridgeReady', _this7.onBridgeReady);
              document.attachEvent('onWeixinJSBridgeReady', _this7.onBridgeReady);
            }
          } else {
            _this7.onBridgeReady();
          }
        } else {
          //钉钉环境
          _this7.setDtConfig();
        }
      });
    },

    /**
     * @function取消订单
     */
    cancelClick: function cancelClick() {
      var _this8 = this;

      Dialog.confirm({
        title: '是否取消订单？',
        message: '取消订单后将清空菜品',
        confirmButtonColor: '#3399ff'
      }).then(function () {
        _this8.$router.go(-1);
      }).catch(function () {// on cancel
      });
    },
    onCancel: function onCancel() {},
    onConfirm: function onConfirm() {
      this.showConfirm = false;
      this.$router.push('/MealOrdering');
    },
    closeConfirm: function closeConfirm() {
      this.showPay = false;
      this.showPays = false;
    },

    /**
     * @function对象数组排序
     *      wzx
     *   2019.05.06
     **/
    compare: function compare(property) {
      return function (obj1, obj2) {
        var value1 = obj1[property];
        var value2 = obj2[property];
        return value1 - value2; // 升序
      };
    },
    // 查询显示哪个模块
    getRefund: function getRefund() {
      var _this9 = this;

      this.$api.Spend.getRefund().then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this9.$code.success) {
          _this9.$utils.Tools.toastShow(msg);
        } else {
          _this9.setting = data;
        }
      }).catch(function () {
        _this9.$utils.Tools.httpError();
      });
    }
  },
  created: function created() {
    this.showPays = false;
    this.mealList = JSON.parse(this.$utils.Store.getLocalItem('foodList'));
    this.orderDate = this.$route.query.orderDate;
    this.placeId = this.$route.query.placeId;
    this.placeName = this.$route.query.placeName;
    this.windowName = this.$route.query.windowName;
    var date = new Date(this.orderDate);
    this.week = this.weekDay[date.getDay()];
    var hash = {};
    /*es6数组去重*/

    var newArr = this.mealList.reduceRight(function (item, next) {
      hash[next.mealId] ? '' : hash[next.mealId] = true && item.push(next);
      return item;
    }, []);
    var meals = newArr.sort(this.compare('mealId'));

    var _iterator5 = _createForOfIteratorHelper(meals),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var item = _step5.value;
        this.goods.push({
          mealId: item.mealId,
          mealName: item.mealName,
          foods: []
        });
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    var totalPrice = 0;

    var _iterator6 = _createForOfIteratorHelper(this.mealList),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var food = _step6.value;

        var _iterator7 = _createForOfIteratorHelper(this.goods),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _item2 = _step7.value;

            if (food.mealId === _item2.mealId) {
              _item2.foods.push({
                mealId: food.mealId,
                mealName: food.mealName,
                foodId: food.foodId,
                foodName: food.foodName,
                foodPrice: food.foodPrice,
                foodOrder: food.foodOrder,
                foodPhoto: food.foodPhoto,
                foodNum: food.foodNum,
                foodUse: food.foodUse,
                merchantId: food.merchantId
              });
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        totalPrice += parseFloat((food.foodPrice * food.foodOrder).toFixed(2));
        this.totalNum += food.foodOrder;
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    this.totalPrice = Math.round(totalPrice * 100) / 100;
    this.getOrderInfo();
    this.getAddressList();
    this.getRefund();
    this.getPlace();
  },
  mounted: function mounted() {
    var windowHeight = document.querySelector('body').clientHeight;
    var AllPageHeight = document.getElementsByClassName('order-paylingyigeshabibujiasopde')[0].offsetHeight;

    if (windowHeight > AllPageHeight) {
      document.querySelector('.order-paylingyigeshabibujiasopde').style.height = document.querySelector('body').clientHeight + 'px';
    }
  },
  destroyed: function destroyed() {}
};